"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
exports.selectedLuggageFactory = selectedLuggageFactory;
var _map2 = _interopRequireDefault(require("lodash/map"));
var _some2 = _interopRequireDefault(require("lodash/some"));
var _constants = require("../constants");
function luggageFactory(_ref) {
  var _luggage$options;
  var luggage = _ref.luggage,
    $currency = _ref.$currency,
    productId = _ref.productId;
  var label = luggage === null || luggage === void 0 ? void 0 : luggage.label;
  return {
    id: luggage === null || luggage === void 0 ? void 0 : luggage.id,
    label: label,
    freeBaggageAvailable: (0, _some2.default)(luggage === null || luggage === void 0 ? void 0 : luggage.options, function (luggageOption) {
      return (luggageOption === null || luggageOption === void 0 ? void 0 : luggageOption.amount) === 0;
    }),
    options: (0, _map2.default)((_luggage$options = luggage === null || luggage === void 0 ? void 0 : luggage.options) !== null && _luggage$options !== void 0 ? _luggage$options : [], function (luggageOption) {
      return luggageOptionFactory({
        luggageOption: luggageOption,
        $currency: $currency
      });
    }),
    isFullTrip: label === _constants.EXTRA_BAGGAGE_FULL_TRIP,
    productId: productId
  };
}
function selectedLuggageFactory(_ref2) {
  var luggage = _ref2.luggage,
    $currency = _ref2.$currency;
  return {
    id: luggage === null || luggage === void 0 ? void 0 : luggage.id,
    code: luggage === null || luggage === void 0 ? void 0 : luggage.code,
    selectedOption: luggageOptionFactory({
      luggageOption: luggage === null || luggage === void 0 ? void 0 : luggage.selectedOption,
      $currency: $currency
    })
  };
}
function luggageOptionFactory(_ref3) {
  var luggageOption = _ref3.luggageOption,
    $currency = _ref3.$currency;
  var amount = $currency.convertPrice(luggageOption === null || luggageOption === void 0 ? void 0 : luggageOption.amount);
  return {
    code: luggageOption === null || luggageOption === void 0 ? void 0 : luggageOption.code,
    quantity: luggageOption === null || luggageOption === void 0 ? void 0 : luggageOption.quantity,
    weight: luggageOption === null || luggageOption === void 0 ? void 0 : luggageOption.weight,
    maxWeight: luggageOption === null || luggageOption === void 0 ? void 0 : luggageOption.maxWeight,
    maxQuantity: luggageOption === null || luggageOption === void 0 ? void 0 : luggageOption.maxQuantity,
    amount: amount,
    displayAmount: $currency.formatPriceWithDecimals(amount, 0),
    currency: $currency.currentCurrency,
    apiPayload: luggageOption
  };
}
var _default = exports.default = luggageFactory;